import React from 'react';
import {View, StyleSheet, Text} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import {onboardingColors} from '../theme/onboardingColors';

const STEP_ICONS = ['account-outline', 'phone-outline', 'shield-check-outline', 'store-outline', 'map-marker-outline'];
const STEP_LABELS = ['You', 'Phone', 'Verify', 'Store', 'Address'];

const StepIndicator = ({currentStep, totalSteps = 5}) => {
  return (
    <View style={styles.container}>
      {Array.from({length: totalSteps}, (_, index) => {
        const stepNum = index + 1;
        const isActive = stepNum === currentStep;
        const isDone = stepNum < currentStep;

        return (
          <View key={index} style={styles.stepWrapper}>
            {index > 0 && (
              <View style={[styles.line, isDone && styles.lineDone]} />
            )}
            <View style={[
              styles.circle,
              isActive && styles.circleActive,
              isDone && styles.circleDone,
            ]}>
              {isDone ? (
                <Icon name="check" size={14} color={onboardingColors.white} />
              ) : (
                <Icon
                  name={STEP_ICONS[index] || 'circle-outline'}
                  size={14}
                  color={isActive ? onboardingColors.white : onboardingColors.dot}
                />
              )}
            </View>
            <Text style={[
              styles.label,
              isActive && styles.labelActive,
              isDone && styles.labelDone,
            ]}>
              {STEP_LABELS[index] || `${stepNum}`}
            </Text>
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'center',
    marginVertical: 16,
  },
  stepWrapper: {
    alignItems: 'center',
    flexDirection: 'column',
  },
  line: {
    position: 'absolute',
    top: 13,
    right: '50%',
    width: 30,
    height: 2,
    backgroundColor: onboardingColors.dot,
    transform: [{translateX: -15}],
  },
  lineDone: {
    backgroundColor: onboardingColors.primary,
  },
  circle: {
    width: 28,
    height: 28,
    borderRadius: 14,
    borderWidth: 2,
    borderColor: onboardingColors.dot,
    backgroundColor: onboardingColors.white,
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 10,
  },
  circleActive: {
    borderColor: onboardingColors.primary,
    backgroundColor: onboardingColors.primary,
  },
  circleDone: {
    borderColor: onboardingColors.primary,
    backgroundColor: onboardingColors.primary,
  },
  label: {
    fontSize: 10,
    fontWeight: '500',
    color: onboardingColors.dot,
    marginTop: 4,
  },
  labelActive: {
    color: onboardingColors.primary,
    fontWeight: '700',
  },
  labelDone: {
    color: onboardingColors.primary,
  },
});

export default StepIndicator;
